import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logo1.png';
import _imports_1 from '../../assets/logo2.png';
import _imports_2 from '../../assets/logo3.png';
import _imports_3 from '../../assets/logo4.png';
import _imports_4 from '../../assets/icon_close.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-ae56ea7c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "top",
  id: "content"
};
var _hoisted_2 = ["src"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_title"
  }, [/*#__PURE__*/_createTextVNode(" 百城愿景 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 成为一流的儿童健康阅读服务商 ")], -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner_abs"
  }, " BECOME A FIRST-CLASS CHILDREN'S READING HEALTH SERVICE PROVIDER.I HOPE EVERY CHILD WILL LOVE READING ", -1);
});

var _hoisted_5 = {
  class: "block"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title"
  }, "BUSINESS PARTNERS", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title2"
  }, "合作伙伴", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_border"
  }, null, -1);
});

var _hoisted_9 = {
  class: "block_company"
};
var _hoisted_10 = {
  key: 0,
  class: "adddialog"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "提交您的需求", -1);
});

var _hoisted_12 = {
  class: "addform"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_carousel_item = _resolveComponent("el-carousel-item");

  var _component_el_carousel = _resolveComponent("el-carousel");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_SIdentify = _resolveComponent("SIdentify");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    interval: 5000,
    loop: "true"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, function (item) {
        return _openBlock(), _createBlock(_component_el_carousel_item, {
          key: item
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("img", {
              src: item.url,
              class: "banner"
            }, null, 8, _hoisted_2), _hoisted_3, _hoisted_4];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: _imports_0,
    class: "logo_img",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.handleXiaochong && _ctx.handleXiaochong.apply(_ctx, arguments);
    })
  }), _createElementVNode("img", {
    src: _imports_1,
    class: "logo_img",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.handleYilianju && _ctx.handleYilianju.apply(_ctx, arguments);
    })
  }), _createElementVNode("img", {
    src: _imports_2,
    class: "logo_img",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.handleObook && _ctx.handleObook.apply(_ctx, arguments);
    })
  }), _createElementVNode("img", {
    src: _imports_3,
    class: "logo_img",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.handleWF && _ctx.handleWF.apply(_ctx, arguments);
    })
  })]), _createElementVNode("div", {
    class: "block_btn",
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.handleAdd && _ctx.handleAdd.apply(_ctx, arguments);
    })
  }, "合作加盟")]), _ctx.adddialog ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("img", {
    src: _imports_4,
    class: "close_icon",
    onClick: _cache[5] || (_cache[5] = function () {
      return _ctx.handleClose && _ctx.handleClose.apply(_ctx, arguments);
    })
  }), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_form, {
    model: _ctx.form,
    rules: _ctx.rules,
    ref: "formRef"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_form_item, {
        prop: "name"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.form.name,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return _ctx.form.name = $event;
            }),
            placeholder: "请输入您的姓名..."
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_el_form_item, {
        prop: "phone"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.form.phone,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
              return _ctx.form.phone = $event;
            }),
            placeholder: "请留下您的联系方式/邮箱/手机..."
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_el_form_item, {
        prop: "question"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.form.question,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return _ctx.form.question = $event;
            }),
            type: "textarea",
            rows: 1,
            placeholder: "请留下您的需求..."
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_el_form_item, {
        prop: "code"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.form.code,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
              return _ctx.form.code = $event;
            }),
            placeholder: "请输入验证码..."
          }, {
            append: _withCtx(function () {
              return [_createElementVNode("div", {
                style: {
                  "margin": "0px -20px -11px -20px"
                },
                onClick: _cache[9] || (_cache[9] = function () {
                  return _ctx.refreshCode && _ctx.refreshCode.apply(_ctx, arguments);
                })
              }, [_createVNode(_component_SIdentify, {
                identifyCode: _ctx.identifyCode
              }, null, 8, ["identifyCode"])])];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model", "rules"])]), _createElementVNode("div", {
    class: "send_btn",
    onClick: _cache[11] || (_cache[11] = function () {
      return _ctx.sendForm && _ctx.sendForm.apply(_ctx, arguments);
    })
  }, "发送")])) : _createCommentVNode("", true)], 64);
}